import * as React from 'react'
import { css } from 'styled-components/macro'

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = 'div'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  variant?: 'block' | 'grid'

  /**
   * Set the max-width of the container to the equivalent of this number of
   * standard grid columns (88px column, 28px gutter).
   */
  maxWidth?: 4 | 6 | 8 | 10
}

function Container(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const { variant = 'block', maxWidth, children, ...rest } = props

  return (
    <Root
      ref={ref}
      css={[styles.root, styles.variant[variant], maxWidth && styles.maxWidth[maxWidth]] as any}
      {...rest}
    >
      {children}
    </Root>
  )
}

const styles = {
  root: css`
    width: 100%;

    margin: 0 auto;
    padding-inline: 1rem;

    --container-max-width: 12;
    max-width: calc(var(--container-max-width) * 88px + (var(--container-max-width) - 1) * 28px);
  `,

  variant: {
    block: css``,
    grid: css`
      --container-gutter: 20px;
      --container-gutter-half: calc(var(--container-gutter) / 2);

      @media only screen and (min-width: 711px) {
        --container-gutter: 24px;
      }
      @media only screen and (min-width: 1072px) {
        --container-gutter: 28px;
      }

      display: grid;
      grid-template-columns: repeat(12, 1fr);
    `,
  },

  maxWidth: {
    [4]: css`
      --container-max-width: 4;
    `,
    [6]: css`
      --container-max-width: 6;
    `,
    [8]: css`
      --container-max-width: 8;
    `,
    [10]: css`
      --container-max-width: 10;
    `,
  },
}

export default React.forwardRef(Container)
